import { render, staticRenderFns } from "./multi-drug-rapid-test-cup_h5.vue?vue&type=template&id=e8af3892&scoped=true&"
import script from "./multi-drug-rapid-test-cup_h5.vue?vue&type=script&lang=js&"
export * from "./multi-drug-rapid-test-cup_h5.vue?vue&type=script&lang=js&"
import style0 from "./multi-drug-rapid-test-cup_h5.vue?vue&type=style&index=0&id=e8af3892&scoped=true&lang=less&"
import style1 from "./multi-drug-rapid-test-cup_h5.vue?vue&type=style&index=1&id=e8af3892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8af3892",
  null
  
)

export default component.exports